import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { api_url } from '../../../js_assets/ConfigApp';
import { GetApi } from '../../../js_assets/Network';
import axios from 'axios'

import CircularProgress from '@material-ui/core/CircularProgress';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AppAdminContainer from '../AppAdminContainer'
import DialogTitle from '@material-ui/core/DialogTitle';


import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Hammer from 'react-hammerjs';
import Divider from '@material-ui/core/Divider';
function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 8,
        margin: 12

    },
    divider: {
        width: '100%',
    },
    ButtonSearch: {
        backgroundColor: '#007bff',
        color: 'white',
        '&:hover': {
            background: '#007bff'
        }
    },
    ButtonLocation: {
        backgroundColor: '#4CAF50',
        color: 'white',
        '&:hover': {
            background: '#4CAF50'
        }
    },
    ButtonGuide: {
        backgroundColor: '#74cbc4',
        color: 'white',
        '&:hover': {
            background: '#74cbc4'
        },
        margin: theme.spacing.unit,
        padding: '2px 2px'
    },
    tab: {
        flexGrow: 1,
        marginTop: 2,
        backgroundColor: '#f7faea'

    },
    iocns: {
        fontSize: 18
    }


});

class AdminOffers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offer_data: [],
            loading_state_iocn: true,
            code_offer_data: '',
            code_model: false,
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
        };
    }

    componentDidMount() {
        axios.get(`${api_url}/api/offer/GetOffers`)
            .then(result => {

                this.setState({ offer_data: result.data, loading_state_iocn: false })



            })
            .catch(function (error) {

                //console.log(error);
            })
    }


    handleOpen_code_model = (Code) => {

        const { User_Info } = this.state;

        this.setState({ loading_state_iocn: true })

        let Used_Offer_Code_model = {

            Offer_Id: Code.offer_Id,
            UserId: User_Info.UserID
        }

        axios.post(`${api_url}/api/offer/Check_Used_Offer_Code`, JSON.stringify(Used_Offer_Code_model), { headers: { 'Content-type': 'application/json; charset=utf-8' } })
            .then(result => {

                if (result.data === false) {

                    //console.log(result.data)


                    axios.post(`${api_url}/api/offer/Save_Used_Offer_Code`, JSON.stringify(Used_Offer_Code_model), { headers: { 'Content-type': 'application/json; charset=utf-8' } })
                        .then(() => {

                            this.setState({ code_model: true, code_offer_data: Code.offer_Code, loading_state_iocn: false })

                        })
                        .catch(function (error) {
                            //console.log(error);
                        });


                }
                else {


                    this.setState({ code_model: true, code_offer_data: Code.offer_Code, loading_state_iocn: false })

                }




            })
            .catch(function (error) {
                //console.log(error);
            });





    }

    Delete_offer = (ID) => {

        const { Admin_Info } = this.state;

        GetApi(`/api/Admin/DeleteOffer/${ID}/${Admin_Info.admin_Id}`, Admin_Info.jwT_Token_Admin)
            .then(() => {
                alert("تم الحدف")
            })

    }

    handleClose_code_model = () => {

        this.setState({ code_model: false, code_offer_data: "" })
    }



    redirectToUrl = (Component) => {

        window.location.href = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + Component
    }

    render() {
        const { classes } = this.props;
        const { offer_data, loading_state_iocn } = this.state;

        //console.log(offer_data);
        return (

            <AppAdminContainer Title={"العروض"} >
                <div>

                    <div>
                        <Grid container justify="center">
                            <Hammer onTap={() => this.redirectToUrl('/Admin/FormOffers?offer_Id=New')}>
                                <div>
                                    <button size="small" variant="contained" className={classes.ButtonGuide}   >
                                        <label> اضافة  عرض جديد</label>
                                    </button>
                                </div>
                            </Hammer>
                        </Grid>
                    </div>


                    <Divider className={classes.divider} />

                    {loading_state_iocn ? <div className="centerloadingicon" ><CircularProgress /></div> : offer_data.length == 0 ? null :

                        offer_data.map((off) => {

                            return (
                                <div>
                                    <div className="cardOffer">
                                        <img src={`${api_url}/Content/Advertising_Images/${off.offer_Image}`} />
                                        <div className="containerOffer">
                                            <h4><b> {off.offer_StoreName}</b></h4>
                                            <hr></hr>
                                            <p>{off.offer_Description}</p>
                                            <span>  عدد اكواد الخصم المتبقية : </span> <span>{off.code_Remaining}</span>
                                            <hr></hr>
                                            <Grid justify="center" alignItems="center" container spacing={8}>
                                                <Grid item sm={4} >
                                                    <button variant="contained"
                                                        className={classes.ButtonGuide}
                                                        onClick={() => this.redirectToUrl(`/Admin/FormOffers?offer_Id=${off.offer_Id}`)}
                                                    >
                                                        <label>تحديث</label>
                                                    </button>
                                                </Grid>

                                                <Grid item sm={4} >
                                                    <button style={{ backgroundColor: 'red' }}
                                                        variant="contained"
                                                        className={classes.ButtonGuide}
                                                        onClick={() => { if (window.confirm('هل متاكد انك تبغى تحدف  ؟؟')) this.Delete_offer(off.offer_Id) }}

                                                    >
                                                        <label>حذف</label>
                                                    </button>
                                                </Grid>

                                            </Grid>
                                        </div>
                                    </div>

                                </div>

                            )



                        })

                    }
                    {/* {loading_state_iocn ? <div className="centerloadingicon" ><CircularProgress /></div> : null} */}


                </div>


                <Dialog
                    open={this.state.code_model}
                    onClose={this.handleClose_code_model}
                    TransitionComponent={Transition}
                    keepMounted

                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <label>كود الخصم هو  </label>  <br></br> <hr></hr>   <span>{this.state.code_offer_data} </span> <br></br> <hr></hr>  <label> عليك بالعافية</label>
                    </DialogTitle>


                </Dialog>


            </AppAdminContainer >




        )
    }


}
AdminOffers.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminOffers);